// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.datatable-wrapper.no-header .datatable-container {
	border-top: 1px solid #d9d9d9;
}

.datatable-wrapper.no-footer .datatable-container {
	border-bottom: 1px solid #d9d9d9;
}

.datatable-top,
.datatable-bottom {
	padding: 8px 10px;
}

.datatable-top > nav:first-child,
.datatable-top > div:first-child,
.datatable-bottom > nav:first-child,
.datatable-bottom > div:first-child {
	float: left;
}

.datatable-top > nav:last-child,
.datatable-top > div:not(first-child),
.datatable-bottom > nav:last-child,
.datatable-bottom > div:last-child {
	float: right;
}

.datatable-selector {
	padding: 6px;
}

.datatable-input {
	padding: 6px 12px;
}

.datatable-info {
	margin: 7px 0;
}

/* PAGER */
.datatable-pagination ul {
	margin: 0;
	padding-left: 0;
}

.datatable-pagination li {
	list-style: none;
	float: left;
}

.datatable-pagination li.datatable-hidden {
    visibility: hidden;
}

.datatable-pagination a,
.datatable-pagination button {
	border: 1px solid transparent;
	float: left;
	margin-left: 2px;
	padding: 6px 12px;
	position: relative;
	text-decoration: none;
	color: #333;
    cursor: pointer;
}

.datatable-pagination a:hover,
.datatable-pagination button:hover {
	background-color: #d9d9d9;
}

.datatable-pagination .datatable-active a,
.datatable-pagination .datatable-active a:focus,
.datatable-pagination .datatable-active a:hover,
.datatable-pagination .datatable-active button,
.datatable-pagination .datatable-active button:focus,
.datatable-pagination .datatable-active button:hover {
	background-color: #d9d9d9;
	cursor: default;
}

.datatable-pagination .datatable-ellipsis a,
.datatable-pagination .datatable-disabled a,
.datatable-pagination .datatable-disabled a:focus,
.datatable-pagination .datatable-disabled a:hover,
.datatable-pagination .datatable-ellipsis button,
.datatable-pagination .datatable-disabled button,
.datatable-pagination .datatable-disabled button:focus,
.datatable-pagination .datatable-disabled button:hover {
    pointer-events: none;
    cursor: default;
}

.datatable-pagination .datatable-disabled a,
.datatable-pagination .datatable-disabled a:focus,
.datatable-pagination .datatable-disabled a:hover,
.datatable-pagination .datatable-disabled button,
.datatable-pagination .datatable-disabled button:focus,
.datatable-pagination .datatable-disabled button:hover {
	cursor: not-allowed;
	opacity: 0.4;
}

.datatable-pagination .datatable-pagination a,
.datatable-pagination .datatable-pagination button {
	font-weight: bold;
}

/* TABLE */
.datatable-table {
	max-width: 100%;
	width: 100%;
	border-spacing: 0;
	border-collapse: separate;
}

.datatable-table > tbody > tr > td,
.datatable-table > tbody > tr > th,
.datatable-table > tfoot > tr > td,
.datatable-table > tfoot > tr > th,
.datatable-table > thead > tr > td,
.datatable-table > thead > tr > th {
	vertical-align: top;
	padding: 8px 10px;
}

.datatable-table > thead > tr > th {
	vertical-align: bottom;
	text-align: left;
	border-bottom: 1px solid #d9d9d9;
}

.datatable-table > tfoot > tr > th {
	vertical-align: bottom;
	text-align: left;
	border-top: 1px solid #d9d9d9;
}

.datatable-table th {
	vertical-align: bottom;
	text-align: left;
}

.datatable-table th a {
	text-decoration: none;
	color: inherit;
}

.datatable-table th button,
.datatable-pagination-list button {
    color: inherit;
    border: 0;
    background-color: inherit;
    cursor: pointer;
    text-align: inherit;
    font-family: inherit;
    font-weight: inherit;
    font-size: inherit;
}

.datatable-sorter, .datatable-filter {
	display: inline-block;
	height: 100%;
	position: relative;
	width: 100%;
}

.datatable-sorter::before,
.datatable-sorter::after {
	content: "";
	height: 0;
	width: 0;
	position: absolute;
	right: 4px;
	border-left: 4px solid transparent;
	border-right: 4px solid transparent;
	opacity: 0.2;
}


.datatable-sorter::before {
	border-top: 4px solid #000;
	bottom: 0px;
}

.datatable-sorter::after {
	border-bottom: 4px solid #000;
	border-top: 4px solid transparent;
	top: 0px;
}

.datatable-ascending .datatable-sorter::after,
.datatable-descending .datatable-sorter::before,
.datatable-ascending .datatable-filter::after,
.datatable-descending .datatable-filter::before {
	opacity: 0.6;
}

.datatable-filter::before {
    content: "";
    position: absolute;
    right: 4px;
    opacity: 0.2;
    width: 0;
    height: 0;
    border-left: 7px solid transparent;
    border-right: 7px solid transparent;
	border-radius: 50%;
    border-top: 10px solid #000;
    top: 25%;
}

.datatable-filter-active .datatable-filter::before {
    opacity: 0.6;
}

.datatable-empty {
	text-align: center;
}

.datatable-top::after, .datatable-bottom::after {
	clear: both;
	content: " ";
	display: table;
}

table.datatable-table:focus tr.datatable-cursor > td:first-child {
	border-left: 3px blue solid;
}

table.datatable-table:focus {
	outline: solid 1px black;
    outline-offset: -1px;
}
`, "",{"version":3,"sources":["webpack://./node_modules/simple-datatables/dist/style.css"],"names":[],"mappings":"AAAA;CACC,6BAA6B;AAC9B;;AAEA;CACC,gCAAgC;AACjC;;AAEA;;CAEC,iBAAiB;AAClB;;AAEA;;;;CAIC,WAAW;AACZ;;AAEA;;;;CAIC,YAAY;AACb;;AAEA;CACC,YAAY;AACb;;AAEA;CACC,iBAAiB;AAClB;;AAEA;CACC,aAAa;AACd;;AAEA,UAAU;AACV;CACC,SAAS;CACT,eAAe;AAChB;;AAEA;CACC,gBAAgB;CAChB,WAAW;AACZ;;AAEA;IACI,kBAAkB;AACtB;;AAEA;;CAEC,6BAA6B;CAC7B,WAAW;CACX,gBAAgB;CAChB,iBAAiB;CACjB,kBAAkB;CAClB,qBAAqB;CACrB,WAAW;IACR,eAAe;AACnB;;AAEA;;CAEC,yBAAyB;AAC1B;;AAEA;;;;;;CAMC,yBAAyB;CACzB,eAAe;AAChB;;AAEA;;;;;;;;IAQI,oBAAoB;IACpB,eAAe;AACnB;;AAEA;;;;;;CAMC,mBAAmB;CACnB,YAAY;AACb;;AAEA;;CAEC,iBAAiB;AAClB;;AAEA,UAAU;AACV;CACC,eAAe;CACf,WAAW;CACX,iBAAiB;CACjB,yBAAyB;AAC1B;;AAEA;;;;;;CAMC,mBAAmB;CACnB,iBAAiB;AAClB;;AAEA;CACC,sBAAsB;CACtB,gBAAgB;CAChB,gCAAgC;AACjC;;AAEA;CACC,sBAAsB;CACtB,gBAAgB;CAChB,6BAA6B;AAC9B;;AAEA;CACC,sBAAsB;CACtB,gBAAgB;AACjB;;AAEA;CACC,qBAAqB;CACrB,cAAc;AACf;;AAEA;;IAEI,cAAc;IACd,SAAS;IACT,yBAAyB;IACzB,eAAe;IACf,mBAAmB;IACnB,oBAAoB;IACpB,oBAAoB;IACpB,kBAAkB;AACtB;;AAEA;CACC,qBAAqB;CACrB,YAAY;CACZ,kBAAkB;CAClB,WAAW;AACZ;;AAEA;;CAEC,WAAW;CACX,SAAS;CACT,QAAQ;CACR,kBAAkB;CAClB,UAAU;CACV,kCAAkC;CAClC,mCAAmC;CACnC,YAAY;AACb;;;AAGA;CACC,0BAA0B;CAC1B,WAAW;AACZ;;AAEA;CACC,6BAA6B;CAC7B,iCAAiC;CACjC,QAAQ;AACT;;AAEA;;;;CAIC,YAAY;AACb;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,YAAY;IACZ,QAAQ;IACR,SAAS;IACT,kCAAkC;IAClC,mCAAmC;CACtC,kBAAkB;IACf,2BAA2B;IAC3B,QAAQ;AACZ;;AAEA;IACI,YAAY;AAChB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,WAAW;CACX,YAAY;CACZ,cAAc;AACf;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,wBAAwB;IACrB,oBAAoB;AACxB","sourcesContent":[".datatable-wrapper.no-header .datatable-container {\n\tborder-top: 1px solid #d9d9d9;\n}\n\n.datatable-wrapper.no-footer .datatable-container {\n\tborder-bottom: 1px solid #d9d9d9;\n}\n\n.datatable-top,\n.datatable-bottom {\n\tpadding: 8px 10px;\n}\n\n.datatable-top > nav:first-child,\n.datatable-top > div:first-child,\n.datatable-bottom > nav:first-child,\n.datatable-bottom > div:first-child {\n\tfloat: left;\n}\n\n.datatable-top > nav:last-child,\n.datatable-top > div:not(first-child),\n.datatable-bottom > nav:last-child,\n.datatable-bottom > div:last-child {\n\tfloat: right;\n}\n\n.datatable-selector {\n\tpadding: 6px;\n}\n\n.datatable-input {\n\tpadding: 6px 12px;\n}\n\n.datatable-info {\n\tmargin: 7px 0;\n}\n\n/* PAGER */\n.datatable-pagination ul {\n\tmargin: 0;\n\tpadding-left: 0;\n}\n\n.datatable-pagination li {\n\tlist-style: none;\n\tfloat: left;\n}\n\n.datatable-pagination li.datatable-hidden {\n    visibility: hidden;\n}\n\n.datatable-pagination a,\n.datatable-pagination button {\n\tborder: 1px solid transparent;\n\tfloat: left;\n\tmargin-left: 2px;\n\tpadding: 6px 12px;\n\tposition: relative;\n\ttext-decoration: none;\n\tcolor: #333;\n    cursor: pointer;\n}\n\n.datatable-pagination a:hover,\n.datatable-pagination button:hover {\n\tbackground-color: #d9d9d9;\n}\n\n.datatable-pagination .datatable-active a,\n.datatable-pagination .datatable-active a:focus,\n.datatable-pagination .datatable-active a:hover,\n.datatable-pagination .datatable-active button,\n.datatable-pagination .datatable-active button:focus,\n.datatable-pagination .datatable-active button:hover {\n\tbackground-color: #d9d9d9;\n\tcursor: default;\n}\n\n.datatable-pagination .datatable-ellipsis a,\n.datatable-pagination .datatable-disabled a,\n.datatable-pagination .datatable-disabled a:focus,\n.datatable-pagination .datatable-disabled a:hover,\n.datatable-pagination .datatable-ellipsis button,\n.datatable-pagination .datatable-disabled button,\n.datatable-pagination .datatable-disabled button:focus,\n.datatable-pagination .datatable-disabled button:hover {\n    pointer-events: none;\n    cursor: default;\n}\n\n.datatable-pagination .datatable-disabled a,\n.datatable-pagination .datatable-disabled a:focus,\n.datatable-pagination .datatable-disabled a:hover,\n.datatable-pagination .datatable-disabled button,\n.datatable-pagination .datatable-disabled button:focus,\n.datatable-pagination .datatable-disabled button:hover {\n\tcursor: not-allowed;\n\topacity: 0.4;\n}\n\n.datatable-pagination .datatable-pagination a,\n.datatable-pagination .datatable-pagination button {\n\tfont-weight: bold;\n}\n\n/* TABLE */\n.datatable-table {\n\tmax-width: 100%;\n\twidth: 100%;\n\tborder-spacing: 0;\n\tborder-collapse: separate;\n}\n\n.datatable-table > tbody > tr > td,\n.datatable-table > tbody > tr > th,\n.datatable-table > tfoot > tr > td,\n.datatable-table > tfoot > tr > th,\n.datatable-table > thead > tr > td,\n.datatable-table > thead > tr > th {\n\tvertical-align: top;\n\tpadding: 8px 10px;\n}\n\n.datatable-table > thead > tr > th {\n\tvertical-align: bottom;\n\ttext-align: left;\n\tborder-bottom: 1px solid #d9d9d9;\n}\n\n.datatable-table > tfoot > tr > th {\n\tvertical-align: bottom;\n\ttext-align: left;\n\tborder-top: 1px solid #d9d9d9;\n}\n\n.datatable-table th {\n\tvertical-align: bottom;\n\ttext-align: left;\n}\n\n.datatable-table th a {\n\ttext-decoration: none;\n\tcolor: inherit;\n}\n\n.datatable-table th button,\n.datatable-pagination-list button {\n    color: inherit;\n    border: 0;\n    background-color: inherit;\n    cursor: pointer;\n    text-align: inherit;\n    font-family: inherit;\n    font-weight: inherit;\n    font-size: inherit;\n}\n\n.datatable-sorter, .datatable-filter {\n\tdisplay: inline-block;\n\theight: 100%;\n\tposition: relative;\n\twidth: 100%;\n}\n\n.datatable-sorter::before,\n.datatable-sorter::after {\n\tcontent: \"\";\n\theight: 0;\n\twidth: 0;\n\tposition: absolute;\n\tright: 4px;\n\tborder-left: 4px solid transparent;\n\tborder-right: 4px solid transparent;\n\topacity: 0.2;\n}\n\n\n.datatable-sorter::before {\n\tborder-top: 4px solid #000;\n\tbottom: 0px;\n}\n\n.datatable-sorter::after {\n\tborder-bottom: 4px solid #000;\n\tborder-top: 4px solid transparent;\n\ttop: 0px;\n}\n\n.datatable-ascending .datatable-sorter::after,\n.datatable-descending .datatable-sorter::before,\n.datatable-ascending .datatable-filter::after,\n.datatable-descending .datatable-filter::before {\n\topacity: 0.6;\n}\n\n.datatable-filter::before {\n    content: \"\";\n    position: absolute;\n    right: 4px;\n    opacity: 0.2;\n    width: 0;\n    height: 0;\n    border-left: 7px solid transparent;\n    border-right: 7px solid transparent;\n\tborder-radius: 50%;\n    border-top: 10px solid #000;\n    top: 25%;\n}\n\n.datatable-filter-active .datatable-filter::before {\n    opacity: 0.6;\n}\n\n.datatable-empty {\n\ttext-align: center;\n}\n\n.datatable-top::after, .datatable-bottom::after {\n\tclear: both;\n\tcontent: \" \";\n\tdisplay: table;\n}\n\ntable.datatable-table:focus tr.datatable-cursor > td:first-child {\n\tborder-left: 3px blue solid;\n}\n\ntable.datatable-table:focus {\n\toutline: solid 1px black;\n    outline-offset: -1px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
